import { Controller } from '@hotwired/stimulus'

const naira = new Intl.NumberFormat('en-NG', {
  style: 'currency',
  currency: 'NGN',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
})
const credits = new Intl.NumberFormat('en-NG', { maximumFractionDigits: 2 })

export default class extends Controller {
  static targets = ['quantity', 'total', 'credits', 'after', 'preset', 'submit']
  static values = { unitPrice: Number, balance: Number }

  connect() {
    // Buttons that open the drawer may carry a quantity, e.g. "Retry" on a failed top-up.
    this.prefill = (event) => {
      const quantity = event.relatedTarget?.dataset?.quantity
      if (quantity) this.quantityTarget.value = quantity
      this.update()
    }
    this.element.addEventListener('show.bs.offcanvas', this.prefill)
    this.update()
  }

  disconnect() {
    this.element.removeEventListener('show.bs.offcanvas', this.prefill)
  }

  update() {
    const quantity = Number(this.quantityTarget.value)
    const valid = Number.isInteger(quantity) && quantity >= 100
    const amount = valid ? quantity : 0
    this.totalTargets.forEach((el) => {
      el.textContent = naira.format((amount * this.unitPriceValue) / 100)
    })
    if (this.hasCreditsTarget)
      this.creditsTarget.textContent = credits.format(amount)
    if (this.hasAfterTarget)
      this.afterTarget.textContent = credits.format(this.balanceValue + amount)
    if (this.hasSubmitTarget) this.submitTarget.disabled = !valid
    this.presetTargets.forEach((el) => {
      el.setAttribute(
        'aria-pressed',
        String(Number(el.dataset.quantity) === quantity),
      )
    })
  }

  select(event) {
    this.quantityTarget.value = event.currentTarget.dataset.quantity
    this.update()
  }
}
